/**
 * Sanitize and encode all HTML in a user-submitted string
 * https://portswigger.net/web-security/cross-site-scripting/preventing
 * @param  {String} str  The user-submitted string
 * @return {String} str  The sanitized string
 */
export function sanitizeHTML(str: string) {
    return str.replace(/[^\w. ]/gi, function (c: string) {
        return '&#' + c.charCodeAt(0) + ';';
    });
};